import { render, staticRenderFns } from "./CategoriesPanel.vue?vue&type=template&id=4d92106f&scoped=true&"
import script from "./CategoriesPanel.vue?vue&type=script&lang=js&"
export * from "./CategoriesPanel.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesPanel.vue?vue&type=style&index=0&id=4d92106f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d92106f",
  null
  
)

export default component.exports